import { assertExists } from '@blocksuite/global/utils';
import {} from '@blocksuite/store';
export function getSelectedContentModels(host, types) {
    const result = [];
    host.std.command
        .pipe()
        .withHost()
        .tryAll(chain => [
        chain.getTextSelection(),
        chain.getBlockSelections(),
        chain.getImageSelections(),
    ])
        .getSelectedBlocks({
        types,
    })
        .inline(ctx => {
        const { selectedBlocks } = ctx;
        assertExists(selectedBlocks);
        result.push(...selectedBlocks.map(el => el.model));
    })
        .run();
    return result;
}
//# sourceMappingURL=selection.js.map